import { Component, OnInit, ViewEncapsulation, OnDestroy, Injectable } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as REGEX from '../../../shared/regex';
import * as LABEL from '../../../shared/labels';
import { PhoneNumberPipe } from '../../../pipes/phoneNumber';
import { MainService } from '../../../services/main/main.service';
import { AuthService } from '../../../services/auth/auth.service';
import moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ProfileDialogComponent } from 'src/app/shared/profile-dialog/profile-dialog.component';
import { LogoutComponentDialog } from 'src/app/layouts/logout-dialog/logout.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { PlaidService } from 'src/app/services/plaid/plaid.service';
import { DatePipe, Location } from '@angular/common';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { take } from 'rxjs/operators';
import { MIN_BIRTH_DATE, SUBSCRIPTION_CHANGE_APIS } from '../../../core/constants/shared-data.constants';
import { getUserProfile, getUserProfiles, getDoctorSettings, getStoredRoleId, setUserProfiles } from 'src/app/core/session';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  providers: [PhoneNumberPipe],
  encapsulation: ViewEncapsulation.None,
})
@Injectable({
  providedIn: 'root'
})
export class ProfileComponent implements OnInit, OnDestroy {
  profileForm: UntypedFormGroup;
  UserRole: any;
  zipCode: number;
  userProfileData: any;
  profileImage: any = '';
  selectedProfileImage: any = '';
  phone_mask = REGEX.mobile_mask;
  dobMask= REGEX.dob_mask;
  public isAdmin: boolean = false;
  public isLocationManager: boolean = false;
  salutations: any = [];
  public label = LABEL;
  bank_error: any = 1;
  maxDate: Date;
  minDate: Date = MIN_BIRTH_DATE;
  isSubmitting: boolean;
  AlternateEmails: any;
  popup: boolean;
  auth_profile1: Subscription;
  auth_profile2: Subscription;
  queryParamSubscription: Subscription;
  tab = 4;
  plad_success_subs: Subscription;
  selected_alternate_email = null;
  sub_details: any;
  showUpcoming= true
  plan_expanded = false;
  keep_same_plan = false;
  sub_status = {
    EXPIRE: 'EXPIRE',
    ACTIVE: 'ACTIVE',
  }
  featuresList = [];
  changeSubApis = SUBSCRIPTION_CHANGE_APIS;
  cardsList = [];
  userProfileData2: any;
  doctorSettings = [];
  custDOB: string;

  constructor(
    private fb: UntypedFormBuilder,
    public dialog: MatDialog,
    public mainService: MainService,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private _ActiveRoute: ActivatedRoute,
    private _router: Router,
    private _plaid_service: PlaidService,
    private _datePipe: DatePipe,
    private location: Location,
  ) {
    this.isAdmin = getStoredRoleId() == 2 ? true : false;
    this.isLocationManager = getStoredRoleId() == 3 ? true : false;
  }

  ngOnInit() {
    this._ActiveRoute.queryParams.subscribe((params)=> {
      if(params && params.tab == 3) {
        this.tab = 3;
      }
      if(params && params.type == 'dispute' || params.tab && params.tab == 'disputes') {
        this.tab = 12;
      }
    })
    this.doctorSettings = localStorage.getItem('doctorSettings') ? getDoctorSettings() : [];
    this.authService.getbankDetails();
    this.mainService.salutations.subscribe((data: any) => {
      if (data && data.length) {
        this.salutations = data;
      }
    });
    this.auth_profile1 = this.authService.userProfileData$.subscribe((data) => {
      if (data && data.length) {
        this.userProfileData = data[0];
        this.UserRole = data[0].role_id;
      }
      if (this.UserRole == 4) {
        this.getBankError();
      }
      if (this.profileForm) {
        this.profileForm.markAsPristine()
      }
      this.initForm()
    })

    this.auth_profile2 = this.authService.getProfileData$.subscribe((data)=>{
      if(data) {
        if(data) {
          this.userProfileData2 = data;
        }
      }
    })
    if (this.isLocationManager) {
    } else {
      this.initForm();
    }
    if (this.UserRole == 4) {
      this.getEmailList();

      this.getBankError();
    }
    else if (this.UserRole == 5) {
      this.tab = 5;
    }
    else {
      this.tab = 1;
      this.removeControls()
    }

    let details = getUserProfiles();

    this.selectedProfileImage = details && details[0] && (details[0].doctor_image || details[0].profile_image || 'assets/img/svg/profile-circle.svg') || 'assets/img/svg/profile-circle.svg';
    let year = new Date().getFullYear();
    let date = new Date().getDate();
    let month = new Date().getMonth();
    this.maxDate = new Date(year - 18, month, date);

    this.queryParamSubscription = this._ActiveRoute.queryParams.subscribe((params) => {
      if (params && params.oauth_state_id) {
        let href = window.location.href;
        this._router.navigate(['/app/profile']);
        let data = {
          plaid_token: localStorage.getItem('plaid_token'),
          receivedRedirectUri: href
        }
        this._plaid_service.openPlaidHandler(data);
      }
      if (params && params.renew) {
        this.tab= 11
      }
    })
    this.plad_success_subs = this._plaid_service.plaid_success_subject.subscribe((data: any) => {
      if (data == 1) {
        this.tab = 3;
        setTimeout(() => {
          this._plaid_service.plaid_success_subject.next(1);
          this.plad_success_subs.unsubscribe();
        }, 0)
      }
    })
    this.getSubscriptionDetails();
    this.getCards();
    if(this._ActiveRoute.snapshot.queryParams['tab'] == 'subscription'){
      this.tab = 11
    }

  }

  ngAfterViewInit() {
    window.addEventListener('click', (event) => {
      if (this.popup == true && event) {
        this.popup = false;
      }
    })
  }

  updateProfilePic(data) {
    let img = new FormData();
    img.append('profile_image', data);
    img.append('access_token', localStorage.getItem('token'));
    this.mainService.uploadApi(img, 'upload_profile_image', true).subscribe((data) => {
      if (data.is_error == 0) {
        this.mainService.profileImage.next(data);
        this.getAuthProfile();
        this.profileImage = '';
        this.profileForm.markAsPristine();
        this.mainService.customPopups('Business logo uploaded successfully.', 0)
      }
    });
  }

  getBankError() {
    let userProfileData = getUserProfiles() && getUserProfile() && getUserProfile();
    if (userProfileData && userProfileData.business_verification_state != 'other_info_updated') {
      this.bank_error = 1;
    } else {
      this.bank_error = 0;
    }
  }

  fileChangeEvent(event: any) {
    event.preventDefault();
    if (event && event.target && event.target.files[0] && event.target.files[0].type.indexOf('image') == -1) {
      this.mainService.customPopups('Please upload a valid file', 2)
      event.target.value = '';
      return
    }
    let file = event.target.files[0];
    if (!(file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg')) {
			this.mainService.customPopups('File format should be png, jpeg, jpg',2);
      event.target.value = '';
			return
		}
    if (file.size > 10485760) {
			this.mainService.customPopups('File size must be less than 10MB.',2);
      event.target.value = '';
			return
		}
    let tillaDialogRef = this.dialog.open(ProfileDialogComponent, {
      width: '512px',
      disableClose: true,
      panelClass: 'simpleDialog',
      data: {
        type: 51,
        title: 'Business Logo',
        image: file,
      },
    });
    tillaDialogRef.afterClosed().subscribe((result) => {
      event.target.value = '';
      if (result !== '0') {
        this.getImageFromService(result);
      } else {
        return false;
      }
    });
  }

  getImageFromService(data) {
    const unsafeImageUrl = URL.createObjectURL(data);
    this.selectedProfileImage = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
    this.profileImage = data;
    this.updateProfilePic(data);
  }

  getZipselected(zipObj: any) {
    try {
      if (zipObj === '') {
        this.profileForm.controls.zipCode.setValue(null);
        this.profileForm.controls.city.setValue(null);
        this.profileForm.controls.State.setValue(null);
        this.profileForm.markAsDirty()
      }
      else {
        this.zipCode = zipObj.zip;
        this.profileForm.controls.zipCode.setValue(zipObj.zip);
        this.profileForm.controls.city.setValue(zipObj.city);
        this.profileForm.controls.city_id.setValue(zipObj.city_id);
        this.profileForm.controls.State.setValue(zipObj.state_name);
        this.profileForm.markAsDirty()
      }
    } catch (err) {
      console.log(err)
    }
  }

  initForm() {
    try {
      if (this.UserRole == 4) {
        let dob = ''
        if(this.userProfileData.date_of_birth) {
          dob = this._datePipe.transform(this.userProfileData.date_of_birth.replace('T00:00:00.000Z',''), "MM/dd/yyyy");
        }
        if (this.userProfileData.practice_address == 'null') {
          this.userProfileData.practice_address = null
        }
        let mobile = this.userProfileData.doctor_mobile || '';
        if (mobile) {
          mobile = mobile.replace('+1-', '');
        }
        this.profileForm = this.fb.group({
          fname: [this.userProfileData.enterprise_first_name || this.userProfileData.doctor_first_name || '', [Validators.required]],
          lname: [this.userProfileData.enterprise_last_name || this.userProfileData.doctor_last_name || '', [Validators.required]],
          email: [{ value: this.userProfileData.enterprise_email || this.userProfileData.doctor_email || '', disabled: true }, [Validators.required]],
          phone: [mobile || '', [Validators.required]],
          mb_since: [
            {
              value:
                moment(this.userProfileData.date_registered).format('MM/DD/yyyy') || '',
              disabled: true,
            },
          ],
          Industry: [{ value: (this.userProfileData.ind_name || ''), disabled: true }],
          Sub_Industry: [{ value: (this.userProfileData.speciality_name || ''), disabled: true }],
          DOB: [dob || undefined, [Validators.required]],
          address: [{ value: this.userProfileData.doctor_address || '', disabled: true }, [Validators.required]],
          zipCode: [{ value: this.userProfileData.doctor_zip || null, disabled: true }, [Validators.required]],
          State: [{ value: this.userProfileData.doctor_state_name || '', disabled: true }],
          city: [{ value: this.userProfileData.doctor_city || '', disabled: true }],
          ind_id: [this.userProfileData.ind_id || ''],
          doctor_speciality: [this.userProfileData.doctor_speciality || ''],
          practice_name: [this.userProfileData.practice_name || ''],
          practice_email: [this.userProfileData.practice_email || ''],
          city_id: [this.userProfileData.doctor_city_id || ''],
          tin: [this.userProfileData.tin ? '*********' : '' || ''],
        });
        if (this.userProfileData.doctor_address) {
          this.profileForm.controls.address.disable();
        }
        if (this.userProfileData.doctor_zip) {
          this.profileForm.controls.zipCode.disable();
        }
        this.zipCode = this.userProfileData.doctor_zip;
      }
      else {
        let mobile = this.userProfileData.enterprise_mobile || '';
        if (mobile.includes(+1)) {
          mobile = mobile.replace('+1-', '');
        }
        this.profileForm = this.fb.group({
          fname: [this.userProfileData.enterprise_first_name || this.userProfileData.doctor_first_name || '', [Validators.required]],
          lname: [this.userProfileData.enterprise_last_name || this.userProfileData.doctor_last_name || '', [Validators.required]],
          email: [{ value: this.userProfileData.enterprise_email || this.userProfileData.doctor_email || '', disabled: true }, [Validators.required]],
          phone: [mobile || '', [Validators.required]],
        });
      }
    } catch (error) {
      console.log(error);

    }
  }

  removeControls() {
    this.profileForm.removeControl('Industry');
    this.profileForm.removeControl('Sub_Industry');
    this.profileForm.removeControl('DOB');
    this.profileForm.removeControl('address');
    this.profileForm.removeControl('zipCode');
    this.profileForm.removeControl('State');
    this.profileForm.removeControl('city');
    this.profileForm.removeControl('ind_id');
    this.profileForm.removeControl('doctor_speciality');
    this.profileForm.removeControl('practice_name');
    this.profileForm.removeControl('practice_email');
    this.profileForm.removeControl('city_id');
  }

  submitProfile() {
    console.log(this.UserRole);

    if (this.UserRole == 4) {
      this.submitProfile_DoctoProfile();
    } else {
      this.submitProfile_enterprice();
    }
  }

  submitProfile_enterprice() {
    if (this.profileForm.invalid) {
      this.isSubmitting = true;
      return;
    }
    let formdata = new FormData();
    formdata.append('access_token', localStorage.getItem('token'));
    formdata.append(
      'enterprise_first_name',
      this.profileForm.controls.fname.value
    );
    formdata.append(
      'enterprise_last_name',
      this.profileForm.controls.lname.value
    );
    formdata.append('enterprise_email', this.profileForm.controls.email.value);
    formdata.append('enterprise_id', this.userProfileData.enterprise_id);
    if (this.profileForm.controls.phone.value) {
      formdata.append(
        'enterprise_mobile',
        '+1-' + this.profileForm.controls.phone.value.replace(/\D+/g, '')
      );
    }
    if (this.profileImage) {
      formdata.append('profile_image', this.profileImage);
      this.profileForm.setErrors({ dirty: true });
    }
    this.mainService.uploadApi(formdata, 'update_enterprise_admin', true)
      .subscribe(async (data: any) => {
        if (data && data.is_error == 0) {
          if (data.result && data.result[0]) {
            this.mainService.customPopups("Profile updated succesfully ", 0);
            setUserProfiles(data.result);
            this.authService.userProfileData$.next([{ ...data.result[0] }])
            this.profileImage = '';
            this.selectedProfileImage = data.result[0].profile_image || 'assets/img/svg/profile-circle.svg';
          }
        }
      });
  }

  submitProfile_DoctoProfile() {
    if (this.profileForm.invalid) {
      this.isSubmitting = true;
      return;
    }
    let xyz;
    if (this.profileForm.controls.DOB.value.includes('/')) {
      xyz =this.profileForm.controls.DOB.value.replaceAll("/","");
    } else {
      xyz = this.profileForm.controls.DOB.value
    }
    const value = xyz.replace(/(\d{2})(\d{2})(\d{4})/, '$3-$1-$2');
    const todayDate =this._datePipe.transform(new Date(), 'yyyy-MM-dd');
    let date = moment(value);
    if (date.isValid()) {
      if (value > todayDate) {
        return false;
      }
      if (new Date(value) > new Date(this.maxDate)) {
        this.mainService.warningText = "Date of Birth should be greater than 18 years";
        return false;
      }
      if (new Date(value) >= new Date('1900-01-01')) {
        this.custDOB = value;
      } else {
        this.mainService.customPopups("Date of birth should be greater than 01/01/1900", 1);
        return;
      }
    } else {
      this.mainService.warningText = "Please enter valid date of birth";
      return;
    }
    let formdata = new FormData();
    formdata.append('access_token', localStorage.getItem('token'));
    formdata.append('doctor_first_name', this.profileForm.controls.fname.value);
    formdata.append('doctor_last_name', this.profileForm.controls.lname.value);
    formdata.append('doctor_email', this.profileForm.controls.email.value);
    formdata.append('ind_id', this.profileForm.controls.ind_id.value);
    formdata.append('doctor_speciality', this.profileForm.controls.doctor_speciality.value);
    formdata.append('ind_name', this.profileForm.controls.Industry.value);
    formdata.append('sub_ind_id', this.profileForm.controls.doctor_speciality.value);
    formdata.append('sub_ind_name', this.profileForm.controls.Sub_Industry.value);
    formdata.append('practice_email', this.userProfileData.practice_email);
    formdata.append('practice_name', this.profileForm.controls.practice_name.value);
    formdata.append('doctor_mobile', '+1-' + this.profileForm.controls.phone.value.toString().replace(/[{()}-]/g, ''));
    formdata.append('doctor_address', this.profileForm.controls.address.value);
    formdata.append('doctor_city_id', this.profileForm.controls.city_id.value);
    formdata.append('device_type', '0');
    formdata.append('device_token', 'website');
    formdata.append('date_of_birth', this.custDOB);
    formdata.append('practice_address', this.userProfileData.practice_address);
    formdata.append('city_id', this.userProfileData.city_id);
    if (this.profileImage) {
      formdata.append('profile_image', this.profileImage)
    }
    this.mainService
      .uploadApi(formdata, 'edit_profile', true)
      .subscribe(async (data: any) => {
        if (data && data.is_error == 0) {
          this.mainService.customPopups("Profile updated succesfully ", 0);
          this.profileForm.setErrors({ dirty: false });
          let userProfileData = localStorage.getItem('userProfileData') && getUserProfiles() && getUserProfile() && getUserProfile();
          setUserProfiles([{ ...userProfileData, ...data.profile[0] }])
          this.authService.userProfileData$.next([{ ...userProfileData, ...data.profile[0] }])
          this.profileImage = '';
          this.selectedProfileImage = userProfileData.doctor_image || userProfileData.profile_image || 'assets/img/svg/profile-circle.svg';
        }
      });
  }

  submitLMProfile() {
    let formdata = new FormData();
    formdata.append('access_token', localStorage.getItem('token'))
    formdata.append('title', this.profileForm.controls.title.value)
    formdata.append('first_name', this.profileForm.controls.fname.value)
    formdata.append('last_name', this.profileForm.controls.lname.value)
    formdata.append('email', this.profileForm.controls.email.value)
    formdata.append('location_manager_id', this.userProfileData.location_manager_id);

    if (this.profileImage) {
      formdata.append('profile_image', this.profileImage);
    }
    if (this.profileForm.controls.phone.value) {
      formdata.append("mobile", '+1-' + this.profileForm.controls.phone.value.replace(/\D+/g, ''));
    }

    this.mainService
      .uploadApi(formdata, 'update_location_manager', true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.selectedProfileImage = '';
          if (data.result && data.result[0]) {
            setUserProfiles(data.result);
            this.authService.userProfileData$.next(data.result);
          }
        }
      });
  }

  altMailPop() {
    let tillaDialogRef = this.dialog.open(ProfileDialogComponent, {
      width: "512px",
      disableClose: true,
      panelClass: "simpleDialog",
      data: {
        type: 52,
        title: "Add Alternate Email",
        disabled: false,
      },
    });
    tillaDialogRef.afterClosed().subscribe((result) => {
      if (result != 0) {
        this.getEmailData(result);
      } else {
        return false;
      }
    });
  }

  getEmailData(data) {
    let accessToken = localStorage.getItem("token");
    let formdata = {};
    formdata["alternate_email"] = data;
    formdata["access_token"] = accessToken;
    this.mainService
      .uploadApi(formdata, "addAlternateEmail", true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.getEmailList();
        }
      });
  }

  getEmailList() {
    let accessToken = localStorage.getItem("token");
    let formdata = {}
    formdata["access_token"] = accessToken;
    this.mainService
      .uploadApi(formdata, "alternate_emails_list", true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.AlternateEmails = data.alternate_emails;
        }
      });
  }

  editEmail(email) {
    event.preventDefault();
    let tillaDialogRef = this.dialog.open(ProfileDialogComponent, {
      width: "512px",
      disableClose: true,
      panelClass: "simpleDialog",
      data: {
        type: 52,
        disabled: false,
        title: "Add Alternate Email",
        email: email.alternate_email,
      },
    });
    tillaDialogRef.afterClosed().subscribe((result) => {
      if (result != 0) {
        let emaillist = email;
        emaillist.alternate_email = result;
        this.editSave(emaillist);
      } else {
        return false;
      }
    });
  }

  editSave(email) {
    let accessToken = localStorage.getItem("token");
    let formdata = {}
    formdata["access_token"] = accessToken
    formdata["dae_id"] = email.dae_id
    formdata["alternate_email"] = email.alternate_email
    this.mainService
      .uploadApi(formdata, "editAlternateEmail", true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.getEmailList();
        }
      });
  }

  sendVerificationsEmail(list) {
    let formdata = {}
    let accessToken = localStorage.getItem("token");
    formdata["access_token"] = accessToken
    formdata["dae_id"] = list.dae_id
    this.mainService
      .uploadApi(formdata, "resend_verification_email", true)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.getEmailList();
          this.mainService.customPopups(
            "Verification email has been send on your email address.",
            0
          );
        }
      });
  }

  deleteEmail(list) {
    let tillaDialogRef = this.dialog.open(ProfileDialogComponent, {
      width: "460px",
      disableClose: true,
      panelClass: "simpleDialog",
      data: {
        type: 52,
        title: "Delete Email Confirmation!",
        email: list.alternate_email,
        disabled: true,
      },
    });
    tillaDialogRef.afterClosed().subscribe((result) => {
      if (result != 0) {
        let accessToken = localStorage.getItem("token");
        let formdata = {};
        formdata["access_token"] = accessToken;
        formdata["dae_id"] = list.dae_id;

        this.mainService
          .uploadApi(formdata, "deleteAlternateEmail", true)
          .subscribe((data: any) => {
            if (data && data.is_error == 0) {
              this.getEmailList();
            }
          });
      }
    });
  }

  show_popup() {
    setTimeout(() => {
      this.popup = !this.popup;
    }, 100);
  }

  async getAuthProfile() {
    await this.authService.accessTokenLogin();
  }

  logout() {
    this.dialog.open(LogoutComponentDialog, {
      width: '420px',
      panelClass: 'simpleDialog'
    });
  }

  ngOnDestroy() {
    this.profileForm.reset();
    this.auth_profile1 && this.auth_profile1.unsubscribe();
    this.auth_profile2 && this.auth_profile2.unsubscribe();
    this.queryParamSubscription && this.queryParamSubscription.unsubscribe();
  }

  changeTab(tab) {
    this.tab = tab;
    const url = this._router
      .createUrlTree([], {
        relativeTo: this._ActiveRoute,
        queryParams: { tab }
      }).toString();


    this.location.replaceState(url);
  }

  getCards() {
    this.userProfileData = getUserProfile();
    const data: any = {
      access_token: localStorage.getItem('token'),
      doctor_id: this.userProfileData.doctor_id
    };
    this.mainService.api(data, `list_all_cards`, false).subscribe(response => {
      if (!response.is_error && response.data) {
        this.cardsList = response.data;
      }
    });
  }

  addCardPop() {
    let doctorProFile = getUserProfiles();
    if (doctorProFile && doctorProFile.length) {
      doctorProFile = doctorProFile[0];
    }
    let confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
      width: '500px',
      panelClass: 'rightFullDialog',
      data: {
        type: '51',
        title: 'Select/Add Card for subscription',
        send_data: {
          address_1: doctorProFile['doctor_address'] || '',
          state: doctorProFile['doctor_state_name'] || '',
          zip_code: doctorProFile['doctor_zip'] || null,
          city: doctorProFile['doctor_city'] || '',
          country_code: doctorProFile['country_code'] || '',
          checked: false,
          type: '',
          card_list: this.cardsList,
          showDefault: false,
          user_info: getUserProfile(),
          current_card: this.sub_details
        }
      }
    });
    confirmDialogRef.afterClosed().subscribe(result => {
      if (result && result.result === 1) {
        const obj = {};
        if (result.card_response && result.card_response.setupIntent) {
          const resp = result.card_response.setupIntent;
          const addCardData: any = {
            access_token: localStorage.getItem('token'),
            stripe_token: result.card_response.setupIntent.payment_method,
            payment_source_type: 2,
            seti_id: result.card_response.setupIntent.id,
          };
          this.mainService.api(addCardData, `add_doctor_card`, false, 'object')
            .subscribe(response => {
              if (!response.is_error) {
                this.bindCardToSubscription(response.source_id, response.last4, response.brand);
              }
            });
        } else if (result.result && result.source_id) {
          const cardItem = this.cardsList.find(item => item.source_id == result.source_id);
          this.bindCardToSubscription(result.source_id, cardItem['last4'], cardItem['brand']);
        }
      }
    });
  }

  addRestoreCardPop() {
    let doctorProFile = getUserProfiles();
    if (doctorProFile && doctorProFile.length) {
      doctorProFile = doctorProFile[0];
    }
    let confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
      width: '500px',
      panelClass: 'rightFullDialog',
      data: {
        type: '603',
        title: 'Select/Add Card for subscription',
        send_data: {
          address_1: doctorProFile['doctor_address'] || '',
          state: doctorProFile['doctor_state_name'] || '',
          zip_code: doctorProFile['doctor_zip'] || null,
          city: doctorProFile['doctor_city'] || '',
          country_code: doctorProFile['country_code'] || '',
          checked: false,
          type: '',
          card_list: this.cardsList,
          showDefault: false,
          user_info: getUserProfile(),
          current_card: this.sub_details
        }
      }
    });
    confirmDialogRef.afterClosed().subscribe(result => {
      if (result && result.result === 1) {
        const obj = {};
        if (result.card_response && result.card_response.token) {
          const resp = result.card_response.token;
          const addCardData: any = {
            access_token: localStorage.getItem('token'),
            stripe_token: result.card_response.token.id,
            payment_source_type: 2
          };
          this.mainService.api(addCardData, `add_doctor_card`, false, 'object')
            .subscribe(response => {
              if (!response.is_error) {
                this.restore_subscription = this.dialog.open(SimpleDialogComponent, {
                  width: '512px',
                  disableClose: true,
                  panelClass: 'simpleDialog',
                  data: {
                    type: 301,
                    title: 'Are you sure you want to cancel subscription?',
                    send_data: {
                      cancel: this.sub_details.sub_cancel
                    }
                  },
                });

                this.restore_subscription.afterClosed().subscribe((result) => {
                  if (result == this.changeSubApis.restore_subscription) {
                    this.subscription_cancel_restore(result)
                    this.bindCardToSubscription(response.source_id, resp['card']['last4'], resp['card']['brand']);
                  }
                });
              }
            });
        } else if (result.result && result.source_id) {
          const cardItem = this.cardsList.find(item => item.source_id == result.source_id);
          this.restore_subscription = this.dialog.open(SimpleDialogComponent, {
            width: '512px',
            disableClose: true,
            panelClass: 'simpleDialog',
            data: {
              type: 301,
              title: 'Are you sure you want to cancel subscription?',
              send_data: {
                cancel: this.sub_details.sub_cancel
              }
            },
          });

          this.restore_subscription.afterClosed().subscribe((result) => {
            if (result == this.changeSubApis.restore_subscription) {
              this.subscription_cancel_restore(result)
              this.bindCardToSubscription(result.source_id, cardItem['last4'], cardItem['brand']);
            }
          });
        }
      }
    });
  }

  addCardPopFromCancelFlow() {
    let doctorProFile = getUserProfiles();
    if (doctorProFile && doctorProFile.length) {
      doctorProFile = doctorProFile[0];
    }
    let confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
      width: '500px',
      panelClass: 'rightFullDialog',
      data: {
        type: '604',
        title: 'Select/Add Card for subscription',
        send_data: {
          address_1: doctorProFile['doctor_address'] || '',
          state: doctorProFile['doctor_state_name'] || '',
          zip_code: doctorProFile['doctor_zip'] || null,
          city: doctorProFile['doctor_city'] || '',
          country_code: doctorProFile['country_code'] || '',
          checked: false,
          type: '',
          card_list: this.cardsList,
          showDefault: false,
          user_info: getUserProfile(),
          current_card: this.sub_details
        }
      }
    });
    confirmDialogRef.afterClosed().subscribe(result => {
      if (result && result.result === 1) {
        const obj = {};
        if (result.card_response && result.card_response.token) {
          const resp = result.card_response.token;
          const addCardData: any = {
            access_token: localStorage.getItem('token'),
            stripe_token: result.card_response.token.id,
            payment_source_type: 2
          };
          this.mainService.api(addCardData, `add_doctor_card`, false, 'object')
            .subscribe(response => {
              if (!response.is_error) {
                this.bindCardToSubscriptionFromCancelFlow(response.source_id, resp['card']['last4'], resp['card']['brand']);
              }
            });
        } else if (result.result && result.source_id) {
          const cardItem = this.cardsList.find(item => item.source_id == result.source_id);
          this.bindCardToSubscriptionFromCancelFlow(result.source_id, cardItem['last4'], cardItem['brand']);
        }
      }
    });
  }

  bindCardToSubscriptionFromCancelFlow(source_id, last4, brand) {
    const obj: any = {
      access_token: localStorage.getItem('token'),
      source_id
    };
    this.mainService.api(obj, `update_payment_method`, false, 'object')
      .subscribe(response => {
        if (!response.is_error) {
          let subsData = JSON.parse(localStorage.getItem('subscription_data'));
          subsData.source_id = source_id;
          localStorage.setItem("subscription_data", JSON.stringify(subsData));
          this.keep_same_plan = false;
          this.mainService.customPopups('Card added successfully', 0);
          const obj: any = {
            access_token: localStorage.getItem('token')
          };
          this.mainService.api(obj, `restore_subscription`, false, 'object')
            .subscribe(response => {
              if (!response.is_error) {
                const obj: any = {
                  access_token: localStorage.getItem('token'),
                  sp_id: subsData.sp_id
                };
                this.mainService.api(obj, `update_upcoming_subscription`, false, 'object')
                  .subscribe(response => {
                    if (!response.is_error) {
                      localStorage.removeItem("subscription_data");
                      this.getSubscriptionDetails();
                      this.showUpcoming = false;
                      this.mainService.customPopups('Your subscription has been reverted back to your current plan. No additional charges will be applied for this change.', 0);
                      this._router.navigate(['/app/profile']);
                    }
                  });
              } else {
                this.mainService.customPopups('Something went wrong', 1);
                return;
              }
            });
          return;
        } else {
          this.mainService.customPopups('Something went wrong', 1);
          return;
        }
      });
  }

  bindCardToSubscription(source_id, last4, brand) {
    const obj: any = {
      access_token: localStorage.getItem('token'),
      source_id
    };
    this.mainService.api(obj, `update_payment_method`, false, 'object')
      .subscribe(response => {
        if (!response.is_error) {
          this.sub_details.last4 = last4;
          this.sub_details.brand = brand;
          if (this.keep_same_plan == true) {
            let subsData = JSON.parse(localStorage.getItem('subscription_data'));
            subsData.source_id = source_id;
            localStorage.setItem("subscription_data",JSON.stringify(subsData));
            this.keep_same_plan = false;
            this.cancelUpdateSubscription();
            this.mainService.customPopups('Card added successfully', 0);
          } else {
            this.getCards();
            this.getSubscriptionDetails();
            this.mainService.customPopups('Payment method changed successfully', 0);
          }
          return;
        } else {
          this.mainService.customPopups('Something went wrong', 1);
          return;
        }
      });
  }
  cancel_subscription: any
  restore_subscription: any
  changeSubscription(index) {
    let subs_data = JSON.parse(localStorage.getItem('subscription_data'));
    if (subs_data && subs_data.source_id) {
      if (this.sub_details.sub_cancel == false && index == 1) {
        this.cancel_subscription = this.dialog.open(SimpleDialogComponent, {
          width: '512px',
          disableClose: true,
          panelClass: 'simpleDialog',
          data: {
            type: 300,
            title: 'Are you sure you want to cancel subscription?',
            send_data: {
              cancel: this.sub_details.sub_cancel
            }
          },
        });

        this.cancel_subscription.afterClosed().subscribe((result) => {
          if (result == this.changeSubApis.cancel_subscription) {
            this.subscription_cancel_restore(result)
          }
        });
      } else if (index == 2 && this.sub_details.sub_cancel == true) {
        this.restore_subscription = this.dialog.open(SimpleDialogComponent, {
          width: '512px',
          disableClose: true,
          panelClass: 'simpleDialog',
          data: {
            type: 301,
            title: 'Are you sure you want to cancel subscription?',
            send_data: {
              cancel: this.sub_details.sub_cancel
            }
          },
        });

        this.restore_subscription.afterClosed().subscribe((result) => {
          if (result == this.changeSubApis.restore_subscription) {
            this.subscription_cancel_restore(result)
          }
        });
      }
    } else {
      this.keep_same_plan = true;
      this.addRestoreCardPop();
    }
  }
  subscription_cancel:boolean=false
  subscription_restore:boolean=false
  subscription_cancel_restore(data?) {
    const obj: any = {
      access_token: localStorage.getItem('token')
    };
    this.mainService.api(obj, `${data}`, false, 'object')
      .subscribe(response => {
        if (!response.is_error) {
          if (data === this.changeSubApis.cancel_subscription) {
            this.mainService.customPopups('Subscription cancelled successfully', 0);
            this.subscription_cancel=true
            this.subscription_restore=false
          } else {
            this.mainService.customPopups('Subscription is restored successfully', 0);
            this.subscription_cancel=false
            this.subscription_restore=true
          }
          this.sub_details.sub_cancel = !this.sub_details.sub_cancel;
          console.log(this.sub_details, "helo wrold");
          return;
        } else {
          this.mainService.customPopups('Something went wrong', 1);
          return;
        }
      });
  }
  plan_show:any
  getSubscriptionDetails() {
    const obj = {
      access_token: localStorage.getItem('token')
    }

    this.mainService.getLocationFilter.pipe(take(1)).subscribe((data)=>{
      console.log(data)
    })

    this.mainService.api(obj, `subscription_detail`, false, 'object')
      .subscribe(response => {
        if (!response.is_error) {
          this.sub_details = response.response;
          if (response.response) {
            localStorage.setItem("subscription_data",JSON.stringify(this.sub_details));
          }
          this.mainService.subscription_data = this.sub_details
          this.plan_show=this.sub_details.sub_name
          this.featuresList = [];
          for (let item in this.sub_details.plan_feature) {
            if (this.sub_details.plan_feature[item]['is_allowed']) {
              let data={}
              data['feature_name'] =this.sub_details.plan_feature[item]['feature_name']
              data['feature_order'] =this.sub_details.plan_feature[item]['feature_order']
              this.featuresList.push(data)
            }
          }
        }
        this.featuresList=this.featuresList.sort((a,b)=>{
          return a.feature_order - b.feature_order
        })

      });

  }

  cancelUpdateSubscription() {
    let subs_data = JSON.parse(localStorage.getItem('subscription_data'));
    if (subs_data && subs_data.is_grace_period > 0) {
      this.renewPlan();
    } else {
      if (subs_data && subs_data.source_id) {
        const obj: any = {
          access_token: localStorage.getItem('token'),
          sp_id: this.sub_details.sp_id
        };
        this.mainService.api(obj, `update_upcoming_subscription`, false, 'object')
          .subscribe(response => {
            if (!response.is_error) {
              localStorage.removeItem("subscription_data");
              this.getSubscriptionDetails();
              this.showUpcoming = false;
              this.mainService.customPopups('Your subscription has been reverted back to your current plan. No additional charges will be applied for this change.', 0);
              return;
            } else {
              this.mainService.customPopups('Something went wrong', 1);
              return;
            }
          });
      } else {
        this.keep_same_plan = true;
        this.addCardPop();
      }
    }
  }


  calculateYesterdayDate(date_sent) {
    let month;let year;let day
    if (date_sent) {
      var date = new Date(date_sent);
      date.setDate(date.getDate() - 1);
      year = date.getFullYear();
      month = date.getMonth() + 1;
      month = (month < 10 ? "0" : "") + month;
      day = date.getDate();
      day = (day < 10 ? "0" : "") + day;
      return year + "-" + month + "-" + day + " 00:00:00";
    }
    var date = new Date();
    date.setDate(date.getDate() - 1);
    year = date.getFullYear();
    month = date.getMonth() + 1;
    month = (month < 10 ? "0" : "") + month;
    day = date.getDate();
    day = (day < 10 ? "0" : "") + day;
    return year + "-" + month + "-" + day + " 00:00:00";
  }

  renewPlan() {
    let doctorProFile = getUserProfiles();
    let subsData = JSON.parse(localStorage.getItem('subscription_data'));
    if (doctorProFile && doctorProFile.length) {
      doctorProFile = doctorProFile[0];
    }
    let confirmDialogRef = this.dialog.open(SimpleDialogComponent, {
      width: '500px',
      panelClass: 'rightFullDialog',
      data: {
        type: '704',
        title: 'Select/Add Card for subscription',
        send_data: {
          address_1: doctorProFile['doctor_address'] || '',
          state: doctorProFile['doctor_state_name'] || '',
          zip_code: doctorProFile['doctor_zip'] || null,
          city: doctorProFile['doctor_city'] || '',
          country_code: doctorProFile['country_code'] || '',
          checked: false,
          type: '',
          card_list: this.cardsList,
          showDefault: false,
          user_info: getUserProfile(),
          current_card: this.sub_details
        }
      }
    });
    confirmDialogRef.afterClosed().subscribe(result => {
      let second = 0;
      if (result && result.card_response && result.card_response.token && result.card_response.token.id) {
        second = 4000;
        const resp = result.card_response.token;
        let addCardData = {
          access_token: localStorage.getItem('token'),
          stripe_token: resp.id,
          payment_source_type: 2
        }
        this.mainService.api(addCardData, `add_doctor_card`, false, 'object')
          .subscribe(response => {
            if (!response.is_error) {
              this.bindCardToSubscription(response.source_id, resp['card']['last4'], resp['card']['brand']);
              setTimeout(() => {
                this._router.navigate(['/app/pricing'], { queryParams: { type: 'renew-plan' } });
              }, second);
            } else {
              this.mainService.customPopups(response.err, 1);
              this._router.navigate(['/app/profile']);
              return false;
            }
          });
      }
      else {
        if (result && result.source_id) {
          if (subsData.source_id == result.source_id) {
            this._router.navigate(['/app/pricing'], { queryParams: { type: 'renew-plan' } });
          } else {
            second = 2000;
            this.bindCardToSubscription(result.source_id, result.last4, result.brand);
            setTimeout(() => {
              this._router.navigate(['/app/pricing'], { queryParams: { type: 'renew-plan' } });
            }, second);
          }
        }
      }
    });
  }

  payInAdvance() {
    this._router.navigate(['/app/pricing'], { queryParams: { type: 'pay-in-advance' } });
  }

  changeRoute() {
    this._router.navigate(
      ['/app/profile'],
      { queryParams: { tab: 'disputes'} }
    );
  }

  toggleExpand(){
    this.plan_expanded = !this.plan_expanded
  }

}
